export default {"src":"/_next/static/media/ODS.6cc14255.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};